import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3 4.75C3 4.34375 3.3125 4 3.75 4L16.25 4C16.6562 4 17 4.34375 17 4.75C17 5.1875 16.6562 5.5 16.25 5.5L3.75 5.5C3.3125 5.5 3 5.1875 3 4.75ZM3 9.75C3 9.34375 3.3125 9 3.75 9L16.25 9C16.6562 9 17 9.34375 17 9.75C17 10.1875 16.6562 10.5 16.25 10.5L3.75 10.5C3.3125 10.5 3 10.1875 3 9.75ZM17 14.75C17 15.1875 16.6562 15.5 16.25 15.5L3.75 15.5C3.3125 15.5 3 15.1875 3 14.75C3 14.3438 3.3125 14 3.75 14L16.25 14C16.6562 14 17 14.3437 17 14.75Z"
	})
});
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
